import component from './component';
import { showSnackbar, hideSnackbar } from './actions';
import reducer from './reducer';

export default {
  component: component,
  reducer: reducer,
  show: showSnackbar,
  hide: hideSnackbar
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/Snackbar/index.js
// module id = 1031
// module chunks = 0